module.exports = __webpack_public_path__ + "static/media/recognition.abd7c5d1.mp3";